import {Cloneable} from "@/common/Cloneable";
import {alias, createModelSchema, custom, deserialize, serialize, SKIP} from "serializr";
import {TimeUtils} from "@/common/TimeUtils";
import {Schema} from "@/common/Schema";


export class Metadata extends Cloneable {

    static schema() {
        return custom(
            (v) => {
                return v && !v.empty() ? serialize(Metadata, v) : SKIP;
            },
            (v) => {
                return deserialize(Metadata, v);
            }
        );
    }

    constructor(uid, updated = 0) {
        super();
        this._uid = uid;
        this._updated = updated || TimeUtils.now();
    }

    get uid() {
        return this._uid;
    }

    set uid(value) {
        this._uid = value;
    }

    get updated() {
        return this._updated;
    }

    set updated(value) {
        this._updated = value;
    }

    empty() {
        return this.uid == "";
    }

    clone(target = undefined) {
        if (!target) {
            return super.clone(new Metadata());
        } else if (target instanceof Metadata) {
            return super.clone(target);
        } else {
            console.assert(false);
            return undefined;
        }
    }
}

createModelSchema(Metadata, {
    _uid: alias("uid", Schema.primitive()),
    _updated: alias("updated", Schema.primitive())
});